// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5730) return "static/chunks/44530001-19e6d94e5717f32d.js";
	if (chunkId === 9673) return "static/chunks/9673-fc49384d99b3122b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1712":"1072958c44efd554","8933":"53259b73059d287e"}[chunkId] + ".js";
};